import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { WidgetQuickSurveyResponseUserList } from 'jamespot-user-api';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { JRCModalContent } from '../JRCModal/JRCModalContent';
import { JRCModalLayout } from '../JRCModal/JRCModalLayout';
import { JRCUserList } from '../JRCUserList/JRCUserList';

export type JRCModalUserListProps = {
    open: boolean;
    usersList?: WidgetQuickSurveyResponseUserList;
    title: string;
    handleLoadUsersList: (page: number) => void;
    setOpen: (open: boolean) => void;
    onClose: () => void;
};

export const CSSAvatarWrapper = styled.div<{ overlap?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    overflow: hidden;
    color: ${(props) => props.theme.color.white};
    background-color: ${(props) => props.theme.color.lavender};
    border: 4px solid ${(props) => props.theme.color.white};
    margin-left: ${(props) => (props.overlap ? '-28px' : '0')};
`;

const CSSTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const JRCModalUserList = ({
    open,
    usersList,
    title,
    handleLoadUsersList,
    setOpen,
    onClose,
}: JRCModalUserListProps) => {
    const doOnClose = useCallback(() => {
        setOpen(false);
        onClose();
    }, [onClose, setOpen]);

    return (
        <JRCModalLayout
            variant={'fixed-height'}
            maxHeight={'800px'}
            open={open}
            closeHandler={doOnClose}
            enableClickAwayCloseModal>
            <JRCModalContent
                overflow={'scroll'}
                onClickIconClose={doOnClose}
                title={
                    <CSSTitle>
                        <JRCIcon name="icon-user" size={24} color="black" />
                        {title}
                    </CSSTitle>
                }>
                <JRCUserList onPageChange={handleLoadUsersList} list={usersList} />
            </JRCModalContent>
        </JRCModalLayout>
    );
};
